import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersSalesConceptCategoriesRequestIndex,
  ApiManagersSalesConceptCategoriesResponseIndex,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersSalesConceptCategoriesRequestIndex;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiManagersSalesConceptCategoriesResponseIndex> => {
  const response =
    await new ApiClient().get<ApiManagersSalesConceptCategoriesResponseIndex>(
      "/api/managers/sales_concept_categories",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiManagersSalesConceptCategoriesRequestIndex;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersSalesConceptCategoriesIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiManagersSalesConceptCategoriesResponseIndex> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagersSalesConceptCategoriesIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
